import { Injectable } from '@angular/core';
//third party
import { Subject } from 'rxjs'
@Injectable({
  providedIn: 'root'
})
export class StepProgressBarService {
progressBarLength: number  = 0;
activeStep: number = 1;
stepCount: number = 4;
steps: string[] = [];
progressBarNext$ = new Subject<any>();
progressBarPrevious$ = new Subject<any>();

  constructor() { }

  previousStep() {
    if (this.activeStep >= 2) {
      --this.activeStep;
      this.progressBarLength = ((this.activeStep-1)/(this.stepCount-1));
    }
  }
  nextStep() {
    if (this.activeStep < this.stepCount) {
      ++this.activeStep;
      this.progressBarLength = ((this.activeStep-1)/(this.stepCount-1))
    }
  }
  resetActiveStep() {
    this.activeStep = 1;
    this.progressBarLength = ((this.activeStep-1)/(this.stepCount-1))
  }
}
